import { render, staticRenderFns } from "./PdfPaginator.vue?vue&type=template&id=3c178c48&scoped=true"
import script from "./PdfPaginator.vue?vue&type=script&lang=js"
export * from "./PdfPaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c178c48",
  null
  
)

export default component.exports